import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../actions/lister-actions';
import useCardView from '../../hooks/useCardView';
import TRANSLATIONS from '../../translations/translations@default.json';
import { isAcceptedRegion } from '../../utilities/locale-utilities';

const MoreInfo = ({ FullProductUrl, Code, classes }) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isListView } = useCardView();

	const dispatch = useDispatch();

	const {
		ListerAddToBasketMobileButtonEnabled,
		CustomCategoriesEnabled,
	} = useSelector((state) => state.experimentSwitches);

	if (!FullProductUrl) {
		return null;
	}

	return (
		<button
			type="button"
			href={FullProductUrl}
			onClick={(event) => {
				event.preventDefault();
				window.location.assign(FullProductUrl);

				dispatch(listerClickThrough(Code));
			}}
			className={classnames(
				classes,
				'cta cta-secondary btn btn-secondary text-center w-full',
				{
					'mt-2 mb-2 z-20': isDealsPage,
					'md:mb-0': isDealsPage && isListView,
					'w-full md:mr-0 md:w-full flex justify-center items-center': ListerAddToBasketMobileButtonEnabled,
					'w-full z-20': CustomCategoriesEnabled,
					'mr-1':
						ListerAddToBasketMobileButtonEnabled && !CustomCategoriesEnabled,
					'px-1':
						ListerAddToBasketMobileButtonEnabled && isAcceptedRegion(['ADE']),
				}
			)}
			itemProp="url"
			data-tag-name={`more-info-button-${
				ListerAddToBasketMobileButtonEnabled ? 'mobile' : ''
			}`}
			data-testid="more-info-button">
			{TRANSLATIONS.productList.productCard.moreInfoButton}
		</button>
	);
};

export default MoreInfo;
